import Cookies from 'universal-cookie';

const cookies = new Cookies();

export function isAuth() {
  return !!cookies.get('auth_key');
}

export function setAuthKey(authKey) {
  return cookies.set('auth_key', authKey, { path: '/' });
}

export function getAuthKey() {
  return cookies.get('auth_key');
}

export function removeAuthKey() {
  return cookies.remove('auth_key', { path: '/' });
}

export function login(authKey, href = '/') {
  setAuthKey(authKey);
  window.location.href = href;
}

export function logout(href = '/') {
  removeAuthKey();
  window.location.href = href;
}



// WEBPACK FOOTER //
// ./src/utils/authHelper.js